export default __webpack_public_path__ + "static/media/BurgerKing.57ea7731.jpeg";